module.exports = __webpack_public_path__ + "media/images/icon/add-5c28cc3e17c3727f14e103b3d40fd1ba.svg";